import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TitleBlock = makeShortcode("TitleBlock");
const TextBlock = makeShortcode("TextBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <TitleBlock slots="heading" theme="light" className="titleBlock-align-left pb-0 choose-partnership-title-cta" mdxType="TitleBlock" />
    <h2 {...{
      "id": "choose-a-partnership-type-to-get-access-to-the-specific-tools-you-need"
    }}>{`Choose a partnership type to get access to the specific tools you need.`}</h2>
    <TextBlock slots="heading, text, buttons" width="50%" theme="light" className="align-left bg-grey embedded-partner-cta" mdxType="TextBlock" />
    <h3 {...{
      "id": "oemembedded-partner"
    }}>{`OEM/Embedded Partner.`}</h3>
    <p>{`If you're developing an integration for a customer-facing application or platform, please contact us to learn more about our OEM/Embedded partnership program. Acrobat Sign API licensing is separate from PDF Services API licensing and can give you unique capabilities and flexibility.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "mailto:signembed@adobe.com"
        }}>{`Contact us`}</a></li>
    </ul>
    <TextBlock slots="heading, text, buttons" width="50%" theme="light" className="align-left bg-grey integration-partners-cta" mdxType="TextBlock" />
    <h3 {...{
      "id": "integration-only-partner"
    }}>{`Integration Only Partner.`}</h3>
    <p>{`If you're building an integration between Adobe Acrobat Sign and another application or service for use by our shared customers, please see these additional resources and steps to ensure success.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://adobe.lookbookhq.com/adobesignpartnerpgm/buildtestdeliver"
        }}>{`Learn more`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      